<template>
  <v-container grid-list-md class="pa-0">
    <v-row dense>
      <v-col cols="12">
        <v-list v-if="getItems.length">
          <template v-for="item in getItems">
            <v-list-item :key="item.id" :disabled="!item.id" @click.stop="open(item)">
              <v-list-item-content>
                <v-list-item-subtitle class="caption"><span class="font-weight-bold">入金期日</span>{{ `: ${item.due}` }}&nbsp;<span class="font-weight-bold">請求日</span>{{ `: ${item.charged}` }}</v-list-item-subtitle>
                <v-list-item-title>{{ `計: ${item.total}` }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon small>fal fa-angle-right</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="`div_${item.id}`"></v-divider>
          </template>
        </v-list>
        <v-list v-else>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>登録されている請求書がありません</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'MainPane',
  props: [
    'items'
  ],
  methods: {
    open: function (item) {
      this.$emit('open', item.id)
    }
  },
  computed: {
    getItems () {
      return (this.$props.items && this.$props.items.length) ? this.$props.items.map(it => {
        return {
          id: it.id,
          total: it.sum ? `¥${it.sum.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}` : '¥0',
          due: this.$moment(it.date).format('YYYY/MM/DD'),
          charged: (it.children && it.children.length) ? this.$moment(it.children[0].date).format('YYYY/MM/DD') : ''
        }
      }) : []
    }
  }
}
</script>
